module.exports = __webpack_public_path__ + "static/media/eedc.faddcd4f.svg";